<template>
  <div>
    {{ dependentValue }}
  </div>
</template>

<script>
export default {
  props: {
    itemId: String,
    dependentRoute: String,
    slug: String,
  },
  data: function () {
    return {
      dependentValue: "",
    };
  },
  methods: {
    getDependentValue() {
      let url =
        "/" + this.slug + "/" + this.dependentRoute + "/getById/" + this.itemId;
      return axios
        .get(url)
        .then((response) => {
          console.log("getDependentValue", response);
          // Return the resolved data
          console.log("getDependentValue", response.data.data.name);
          this.dependentValue = response.data.data.name;
          // return response.data.data.name;
        })
        .catch((error) => {
          console.error("Error fetching dependent value:", error);
          // Optionally, you can throw the error to propagate it to the caller
          throw error;
        });
    },
  },
  mounted() {
    this.getDependentValue();
  },
};
</script>

<style>
</style>